export default [
	{
		path: "online_service",
		component: () =>
			import(/* webpackChunkName: "new_hr" */ "@/pages/newWork/index"),
		meta: { title: "在线客服", cate: "招聘管理" },
	},
	{
		path: "agent_management",
		component: () =>
			import(/* webpackChunkName: "new_hr" */ "@/pages/newWork/index"),
		meta: { title: "经纪人管理", cate: "招聘管理" },
	},
	{
		path: "share_reward",
		component: () =>
			import(/* webpackChunkName: "new_hr" */ "@/pages/newWork/index"),
		meta: { title: "分享奖励", cate: "招聘管理" },
	},
	{
		path: "store_management",
		component: () =>
			import(/* webpackChunkName: "new_hr" */ "@/pages/newWork/index"),
		meta: { title: "店铺管理", cate: "招聘管理" },
	},
	{
		path: "browsing_history",
		component: () =>
			import(/* webpackChunkName: "new_hr" */ "@/pages/newWork/index"),
		meta: { title: "浏览记录", cate: "招聘管理" },
	},
	{
		path: "resume_library",
		component: () =>
			import(/* webpackChunkName: "new_hr" */ "@/pages/newWork/index"),
		meta: { title: "简历库", cate: "招聘管理" },
	},
];
